<ion-content no-bounce>
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-no-padding">
      <ion-col
        sizeXs="10"
        offsetXs="1"
        sizeSm="8"
        offsetSm="2"
        sizeMd="6"
        offsetMd="3"
        sizeLg="4"
        offsetLg="4"
        class="ion-margin-top"
      >
        <ion-img class="ion-padding-top ion-margin-top" src="/assets/images/logo_cmillonario.svg"></ion-img>
        <div class="ion-margin">
          <form (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
            <ion-text color="danger" [hidden]="!error || isLoading">
              <span class="ion-padding" translate>{{ error }}</span>
            </ion-text>
            <ion-list>
              <p translate>login.email</p>
              <ion-item class="input" lines="none">
                <ion-input type="email" formControlName="username" autocomplete="username"></ion-input>
              </ion-item>
              <ion-text
                color="danger"
                [hidden]="loginForm.controls['username'].valid || loginForm.controls['username'].untouched"
              >
                <span class="ion-padding" translate>login.emlrequired</span>
              </ion-text>
              <p class="ion-margin-top" translate>login.password</p>
              <ion-item class="input" lines="none">
                <ion-input
                  placeholder="Contraseña"
                  type="password"
                  formControlName="password"
                  autocomplete="current-password"
                >
                  <ion-input-password-toggle slot="end"></ion-input-password-toggle>
                </ion-input>
              </ion-item>
              <ion-text
                color="danger"
                [hidden]="loginForm.controls['password'].valid || loginForm.controls['password'].untouched"
              >
                <span class="ion-padding" translate>login.pssrequired</span>
              </ion-text>

              <ion-button
                (click)="openRecovery('recovery')"
                class="ion-margin-top"
                expand="block"
                fill="clear"
                shape="round"
                translate
              >
                login.forgotpss
              </ion-button>

              <ion-button
                class="ion-margin-top"
                type="submit"
                [disabled]="loginForm.invalid || isLoading"
                color="primary"
                expand="block"
                shape="round"
                translate
              >
                login.Login
              </ion-button>

              <ion-item lines="none">
                <ion-label>
                  <ion-button
                    [routerLink]="['/register']"
                    routerLinkActive="router-link-active"
                    color="secondary"
                    fill="clear"
                    expand="block"
                    shape="round"
                    [disabled]="!isAllowed"
                    translate
                  >
                    login.create
                  </ion-button>
                </ion-label>
              </ion-item>
              <ion-item *ngIf="!isAllowed" lines="none">
                <ion-label color="warning"> <span translate>login.registerMX</span></ion-label>
              </ion-item>

              <!-- <ion-item class="" lines="none">
                <ion-checkbox labelPlacement="end" formControlName="remember" slot="start">{{'Remember me' | translate}}</ion-checkbox>
              </ion-item> -->
            </ion-list>
          </form>

          <ion-item lines="none" class="ion-margin-top">
            <ion-label class="ion-text-center" size="XL">
              <ion-icon
                size="L"
                src="./assets/icons/pg18.svg"
                title="Disponible únicamente para mayores de edad"
              ></ion-icon>
            </ion-label>
          </ion-item>

          <!-- <ion-item button class="input ion-margin-top" lines="none">
            <ion-icon slot="start" name="logo-google"></ion-icon>
            <ion-label>Continuar con Google</ion-label>
          </ion-item>

          <ion-item button class="input ion-margin-vertical" lines="none">
            <ion-icon slot="start" name="logo-apple"></ion-icon>
            <ion-label>Continuar con Apple</ion-label>
          </ion-item>

          <ion-item button class="input" lines="none">
            <ion-icon slot="start" name="logo-facebook"></ion-icon>
            <ion-label>Continuar con Facebook</ion-label>
          </ion-item> -->

          <ion-row class="footer-legal">
            <ion-col size="12" class="ion-text-center">
              <p class="legal-text">
                www.cmillonario.mx Operada en México por Producciones Móviles S.A. de C.V., titular del permiso
                DGAJS/SCEVF/P-06/2005-TER en unión de Unocapali la Paz Operadora S.A. de C.V. de conformidad con los
                oficios DGJS/1580/2021 y DGJS/DCRCA/2090/2022. Juegos prohibidos para menores de edad, juegue
                responsablemente, no olvide que el principal propósito es la recreación, diversión y esparcimiento.
              </p>
            </ion-col>
          </ion-row>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
